module.exports = __webpack_public_path__ + "img/astana-logo-icon.b89f33b6.png";